import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {GlobalMessagesService} from "../../shared/services/global-messages.service";
import {FiltersTab} from "../../shared/models/common.interface";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable,
  MatTableDataSource
} from "@angular/material/table";
import {finalize, Subject, takeUntil} from "rxjs";
import {DISTRIBUTION_TABLE_COLUMNS, FILTER_TABS_CONFIG} from "./distribution-dashboard.config";
import {DistributionsRepository} from "../../shared/repositories/distributions.repository";
import {IDistribution} from "../../shared/models/distributions.interface";
import {FullWidthScrollDirective} from "../../shared/directives/full-width-scroll.directive";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatPaginator} from "@angular/material/paginator";
import {MatTabLink, MatTabNav, MatTabNavPanel} from "@angular/material/tabs";
import {SearchComponent} from "../../shared/components/search/search.component";
import {UploadDialogComponent} from "../../shared/components/upload-dialog/upload-dialog.component";
import {NgOptimizedImage, NgStyle} from "@angular/common";
import {DistributionDialogComponent} from "./distribution-dialog/distribution-dialog.component";
import {IPackage, IPackageDist} from "../../shared/models/packages.interface";

@Component({
  selector: 'app-distribution-dashboard',
  standalone: true,
  imports: [
    FullWidthScrollDirective,
    MatButton,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatPaginator,
    MatRow,
    MatRowDef,
    MatTabLink,
    MatTabNav,
    MatTabNavPanel,
    MatTable,
    SearchComponent,
    UploadDialogComponent,
    MatHeaderCellDef,
    MatMenuTrigger,
    NgStyle,
    NgOptimizedImage
  ],
  templateUrl: './distribution-dashboard.component.html',
  styleUrl: './distribution-dashboard.component.scss'
})
export class DistributionDashboardComponent implements OnInit, OnDestroy {
  filterTabs = FILTER_TABS_CONFIG;
  displayedColumns = DISTRIBUTION_TABLE_COLUMNS;
  data: IDistribution[] = [];
  packagesList: IPackageDist[] = [];
  activeTab: FiltersTab = this.filterTabs[0];
  dataSource = new MatTableDataSource(this.data);
  isInProgress: boolean = false;
  destroy$ = new Subject<void>();

  constructor(private dialog: MatDialog, private messageService: GlobalMessagesService, private distributionsRepository: DistributionsRepository) {}

  ngOnInit() {
    this.getPackagesList();
    this.setData();
  }


  getPackagesList() {
    this.distributionsRepository
      .getAllPackages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: IPackage[]) => {
        this.packagesList = res.map((i) => {
          return {
          id: i.id,
          name: i.name,
          altName: i.altName,
          regionId: i.regionId,
        };
        });
      });
  }

  setData(): void {
    this.isInProgress = true;
    this.distributionsRepository
      .getDistributionsData()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.isInProgress = false))
      )
      .subscribe((res: IDistribution[]) => {
        this.dataSource = new MatTableDataSource(res);
      });
  }

  applyFilter(currentTab: FiltersTab): void {
    this.activeTab = currentTab;
    this.setData();
  }

  createDistribution() {
    this.openDistributionDialog('create');
  }

  editDistribution(distribution: IDistribution) {
    this.openDistributionDialog('edit', distribution);
  }

  openDistributionDialog(type: 'create' | 'edit', distribution?: IDistribution) {
    const dialogRef = this.dialog.open(DistributionDialogComponent, {
      disableClose: false,
      hasBackdrop: true,
      width: '600px',
      data: {
        title: `${type} distribution`,
        type: type,
        distribution: distribution,
        packages: this.packagesList
      }
    });

    dialogRef.afterClosed().subscribe((success: boolean) => {
      if (success) {
        this.setData();
        this.messageService.show('success', 'Distribution was created.');
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
